import { ProgramActionTypes } from '../constants/ApiConstants';

const initialState = {
    loading: false,
    programList: null,
    programListDetails: null,
    programListDetailsByDomain: null,
    deleted_programList: null,
    saved_programList: null,
    programActiveStatus: false,
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case ProgramActionTypes.get_programList.REQUEST:
        case ProgramActionTypes.program_active_status.REQUEST:
            return {
                ...state,
                loading: true,
                programList: null
            };
        case ProgramActionTypes.get_programList.SUCCESS:
            return {
                ...state,
                loading: false,
                programList: payload
            };
        case ProgramActionTypes.get_programDetails.REQUEST:
            return {
                ...state,
                loading: true,
                programListDetails: null
            };
        case ProgramActionTypes.get_programDetails.SUCCESS:
            return {
                ...state,
                loading: false,
                programListDetails: payload
            };
        case ProgramActionTypes.get_programDetailsByDomain.REQUEST:
            return {
                ...state,
                loading: true,
                programListDetailsByDomain: null
            };
        case ProgramActionTypes.get_programDetailsByDomain.SUCCESS:
            return {
                ...state,
                loading: false,
                programListDetailsByDomain: payload
            };
        case ProgramActionTypes.post_program.REQUEST:
            return {
                ...state,
                loading: true,
                saved_programList: null
            };
        case ProgramActionTypes.post_program.SUCCESS:
            return {
                ...state,
                loading: false,
                saved_programList: payload
            };
        case ProgramActionTypes.delete_program.REQUEST:
            return {
                ...state,
                loading: true,
                deleted_programList: null
            };
        case ProgramActionTypes.delete_program.SUCCESS:
            return {
                ...state,
                loading: false,
                deleted_programList: payload
            };
        case ProgramActionTypes.program_active_status.SUCCESS:
            return {
              ...state,
              programActiveStatus: payload,
              loading: false,
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/program/reducers/programReducer.js